import { useEffect, useState } from "react";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { customStyles } from "../Utility/Utility";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";

const NotificationHistory = () => {
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(false);

  const suggestiondata = async () => {
    setloading(true);
    try {
      const obj = { ReceiverId:"",ReceiverType: "User" };
      const res = await AddUpdate("NotificationSegments/GetData_SendNotification", obj);
      const tabledata = res?.data?.data;

      if (tabledata) {
        const rowdata = JSON.parse(tabledata);
        const finaldata = rowdata?.Table;
        setData(finaldata || []);
       
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    suggestiondata();
  }, []);

 const columns = [

  {
    name: "Title",
    selector: (row) => row.Title,
    sortable: true,
  },
  {
    name: "Message",
    selector: (row) => row.Message,
    sortable: true,
    cell: (row) => (
      <div
        title={row.Message}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "200px",
        }}
      >
        {row.Message}
      </div>
    ),
  },
  {
    name: "Receiver Name",
    selector: (row) => row.ReceiverName,
    sortable: true,
  },
  {
    name: "Receiver Type",
    selector: (row) => row.ReceiverType,
    sortable: true,
  },
  {
    name: "Scheduled Time",
    selector: (row) => row.ScheduledDateTime,
    sortable: true,
  },

];


  return (
    <div className="row">
      <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Notification History</h2>
      <div className="col-12 main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={data}
            columns={columns}
            // selectableRowsHighlight
            highlightOnHover
            pagination
            fixedHeader
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
            customStyles={customStyles}
          />

        )}
      </div>
    </div>
  );
};

export default NotificationHistory;
